// API
export * from "./api";

// Components
export * from "./components";

// Composables
export * from "./composables";

/**
 * @fileoverview Address Extension Module for Arad/HoReCa business requirements.
 *
 * This module extends VirtoCommerce addresses with additional fields:
 * - Guild (business type)
 * - Store Name
 * - Location (GPS coordinates for shipping)
 * - Person Type (natural/legal for billing)
 * - Natural Person fields (name, national code, ID card)
 * - Legal Person fields (company name, national code, economic code, business license)
 */
// Constants
export * from "./constants";

// Types
export * from "./types";

// Utilities
export * from "./utils";

// Module initialization
import { loadModuleLocale } from "@/arad/modules/utils";
import type { I18n } from "@/i18n";

/**
 * Initialize the Address Extension module.
 * Call this from the main app initialization to load locales.
 */
export async function initAddressExtensionModule(i18n: I18n): Promise<void> {
  await loadModuleLocale(i18n, "address-extension");
}
